export default "__VITE_ASSET__eef3297d__"